module.exports = __webpack_public_path__ + "static/media/Skinn.8804946a.PNG";